export class callBarService {
    constructor(params) {
        this.SingletonWebSocket = params.SingletonWebSocket;
        this.SingletonSharedData = params.SingletonSharedData;
        this.StateRule = params.StateRule;
    }
    DTMFDigit(digit) {
        const action = "DTMF";
        if (this.StateRule.validate(this.SingletonSharedData.getCurrentStatus(), action)) {
            const message = {
                client: "integration",
                action: "CallAction",
                callAction: action,
                digit: digit
            }
            this.SingletonWebSocket.send(message);
        }
    }

    controlVolume(deviceType, xVol) {
        const message = {
            client: "integration",
            action: "CallAction",
            callAction: "SetVolume",
            device: "",
            vol: parseInt(xVol, 10)
        }
        if (message.vol < 0) {
            message.vol = 10;
        } else if (message.vol > 100) {
            message.vol = 100;
        }
        switch (deviceType) {
            case 0:
                message.device = "Speaker";
                break;
            case 1:
                message.device = "Microphone";
                break;
            default:
                break;
        }
        this.SingletonWebSocket.send(message);
    }

    setMute() {
        const action = "Mute";
        if (this.StateRule.validate(this.SingletonSharedData.getCurrentStatus(), action)) {
            const message = {
                client: "integration",
                action: "CallAction",
                callAction: action
            }
            this.SingletonWebSocket.send(message);
        }
    }

    HoldCall() {
        const action = "Hold";
        if (this.StateRule.validate(this.SingletonSharedData.getCurrentStatus(), action)) {
            const message = {
                client: "integration",
                action: "CallAction",
                callAction: action
            }
            this.SingletonWebSocket.send(message);
        }
    }

    addMark() {
        const message = {
            client: "integration",
            action: "CallAction",
            callAction: "MarkAdd"
        }
        this.SingletonWebSocket.send(message);
    }

    recordingStopStart() {
        const message = {
            client: "integration",
            action: "CallAction",
            callAction: "recordingStopStart"
        }
        this.SingletonWebSocket.send(message);
    }
}


// WEBPACK FOOTER //
// ./src/Services/callBarService.js